// TEMP: Hapus setelah pergantian KTT resmi
import moment from "moment";

/**
 * Jadwal nama Kepala Teknik Tambang.
 * Urutkan dari tanggal terlama ke terbaru.
 *
 * Untuk pergantian berikutnya, cukup tambah baris baru di bawah:
 * { effectiveFrom: "YYYY-MM-DD", name: "Nama Baru", title: "Jabatan" }
 *
 * Entri yang berlaku = entri terakhir yang effectiveFrom <= tanggal referensi.
 */
const KTT_NAME_SCHEDULE = [
  {
    effectiveFrom: "2022-01-01",
    name: "Riadi Simka Pinem",
    title: "Kepala Teknik Tambang",
  },
  {
    effectiveFrom: "2026-06-23",
    name: "SUPANDI",
    title: "Kepala Teknik Tambang",
  },
];

function getActiveKttEntry(referenceDate = new Date()) {
  const date = moment(referenceDate).startOf("day");
  let activeEntry = KTT_NAME_SCHEDULE[0];

  for (const entry of KTT_NAME_SCHEDULE) {
    const effectiveDate = moment(entry.effectiveFrom, "YYYY-MM-DD").startOf(
      "day",
    );
    if (!date.isBefore(effectiveDate)) {
      activeEntry = entry;
    }
  }

  return activeEntry;
}

/**
 * Mengembalikan nama Kepala Teknik Tambang berdasarkan tanggal referensi.
 * @param {Date|string|moment.Moment} [referenceDate=new Date()]
 */
export function getKepalaTeknikTambangName(referenceDate = new Date()) {
  return getActiveKttEntry(referenceDate).name;
}

/**
 * Mengembalikan jabatan Kepala Teknik Tambang berdasarkan tanggal referensi.
 * @param {Date|string|moment.Moment} [referenceDate=new Date()]
 */
export function getKepalaTeknikTambangTitle(referenceDate = new Date()) {
  return getActiveKttEntry(referenceDate).title;
}
